// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'
import { ISecurityProfile } from 'types/graphql'

export interface SecurityProfilesState {
  data: ISecurityProfile[]
}

const initialState: SecurityProfilesState = {
  data: []
}

export const securityProfilesSlice = createSlice({
  name: Reducers.SECURITY_PROFILES,
  initialState,
  reducers: (create) => ({
    setSecurityProfiles: create.reducer((state, action: PayloadAction<ISecurityProfile[]>) => {
      state.data = action.payload
    }),
    updateSecurityProfiles: create.reducer(
      (state, action: PayloadAction<{ id: string, data: ISecurityProfile }>) => {
        state.data = state.data.map(item => {
          if (item.id === action.payload.id) {
            return { ...item, ...action.payload.data }
          }
          return item
        })
      }
    )
  }),
  selectors: {
    securityProfilesSelector: (state) => state.data
  }
})

export const {
  setSecurityProfiles,
  updateSecurityProfiles
} =
  securityProfilesSlice.actions

export const { securityProfilesSelector } = securityProfilesSlice.selectors
